import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {MxButtonModule} from '../mx-button/mx-button.module';
import {MxThumbnailModule} from '../mx-thumbnail/mx-thumbnail.module';
import {MxSharedModule} from '../../shared/mx-shared.module';
import {MxGridComponent} from './components/mx-grid/mx-grid.component';
import {RouterModule} from '@angular/router';
import {MxPaginationComponent} from './components/mx-pagination/mx-pagination.component';

@NgModule({
    imports: [
        MxSharedModule,
        RouterModule,
        MxButtonModule,
        MxThumbnailModule,
        TranslateModule
    ],
    exports: [
        MxGridComponent,
        MxPaginationComponent,
    ],
    declarations: [
        MxGridComponent,
        MxPaginationComponent,
    ]
})

export class MxGridModule { }
